import { render, staticRenderFns } from "./loan-written-off.vue?vue&type=template&id=12a35d04&"
import script from "./loan-written-off.vue?vue&type=script&lang=js&"
export * from "./loan-written-off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports